export default function () {

    const maps = document.querySelectorAll('[data-address]');

    window.initMaps = function () {

        let mapOptions = {
            zoom: 18,
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: true,
            draggable: true
        };

        let counter = 1;

        for (const mapDom of maps) {

            const id = 'map__' + counter;
            const address = mapDom.getAttribute('data-address');
            mapDom.innerHTML = '<div class="map" id="' + id + '"></div>';

            let map = new google.maps.Map(
                document.getElementById(id),
                mapOptions
            );


            let geocoder = new google.maps.Geocoder();
            geocoder.geocode(
                {
                    address: address,
                    componentRestrictions: {
                        country: 'NZ'
                    }
                },
                function (results, status) {
                    if (results && results.length >= 0) {
                        let result = results[0];

                        let latLng = new google.maps.LatLng(
                            result.geometry.location.lat(),
                            result.geometry.location.lng()
                        );
                        var marker = new google.maps.Marker({
                            position: {
                                lat: result.geometry.location.lat(),
                                lng: result.geometry.location.lng(),
                            }
                        });
                        marker.setMap(map);
                        map.setCenter({
                            lat: result.geometry.location.lat(),
                            lng: result.geometry.location.lng(),
                        });
                    }
                }
            );
            counter += 1;
        }
        // maps.each(function() {
        //
        //     const mapDom = $(this);
        //     const id = 'map__' + counter;
        //     const address = mapDom.data('address');
        //     mapDom.html('<div class="map full-width demo-map gradient-overlay no-overflow" id="' + id + '"></div>');
        //
        //
        //     let map = new google.maps.Map(
        //         document.getElementById(id),
        //         mapOptions
        //     );
        //
        //
        //     let geocoder = new google.maps.Geocoder();
        //     geocoder.geocode(
        //         {
        //             address: address,
        //             componentRestrictions: {
        //                 country: 'US'
        //             }
        //         },
        //         function(results, status) {
        //             if (results && results.length >= 0) {
        //                 let result = results[0];
        //
        //                 let latLng = new google.maps.LatLng(
        //                     result.geometry.location.lat(),
        //                     result.geometry.location.lng()
        //                 );
        //                 var marker = new google.maps.Marker({
        //                     position: {
        //                         lat: result.geometry.location.lat(),
        //                         lng: result.geometry.location.lng(),
        //                     }
        //                 });
        //                 marker.setMap(map);
        //                 map.setCenter({
        //                     lat: result.geometry.location.lat(),
        //                     lng: result.geometry.location.lng(),
        //                 });
        //             }
        //         }
        //     );
        //
        //     counter += 1;
        // });
    };

    if (maps && maps.length) {
        const src = '//maps.googleapis.com/maps/api/js?key=' + 'AIzaSyBf3Ka9c3tjf3PbOV5yegXqqtrBrQB_jWg' + '&callback=initMaps';                                                         
        const script = document.createElement('script');
        script.src = src;
        script.type = 'text/javascript';
        document.body.appendChild(script);
    }

}
